import React from 'react'
import { Link } from 'react-router-dom'
import '../setupyourprofile/SetupYourProfile.css'

const SetupYourProfile = () => {
  return (
    <div className='SetupYourProfile-section w-100 position-relative'>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
        <div className='SetupYourProfile-code-box d-flex flex-wrap align-content-center justify-content-center'>
            <div className='inner-SetupYourProfile d-flex flex-wrap align-content-center justify-content-center'>  
                <div className='SetupYourProfile-form w-100'>
                    <h6 className='text-center'>Setup your profile</h6>
                    <div className='SetupYourProfile-code-form w-100'>
                        <form action="" className='form-section'>
                            <div class="col-md-12 upload-file">
                                <label className="d-none form-label" for="">Upload</label>
                                <input type="file" className="form-control" id="" />
                                <span className='file-upload-box d-flex flex-wrap align-items-center justify-content-center'>
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.1816 1.16162V51.1616" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.18164 26.0078H51.1816" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </span>
                            </div>

                            <div className="col-md-12">
                                <label for="" className="d-none form-label">Username</label>
                                <input type="text" className="form-control" id="" placeholder="Username"/>
                            </div>
                            <div className="col-md-12">
                                <label for="" className="d-none form-label">Name</label>
                                <input type="text" className="form-control" id="" placeholder="Name"/>
                            </div>
                            <div className="col-md-12">
                                <label for="" className="d-none form-label">Gender</label>
                                <input type="text" className="form-control" id="" placeholder="Gender"/>
                            </div>
                            <div className="col-md-12">
                                <label for="" className="d-none form-label">Sexuality</label>
                                <input type="text" className="form-control" id="" placeholder="Sexuality"/>
                            </div>
                            <div className="col-md-12">
                                <label for="" className="d-none form-label">User Type</label>
                                <input type="text" className="form-control" id="" placeholder="User Type"/>
                            </div>
                            <div className="col-md-12">
                                <label for="" className="d-none form-label">Bio desription</label>
                                <textarea className="form-control" id="" rows="3" placeholder="Bio desription"></textarea>
                            </div>
                            
                        </form>
                        <p className='text-center mt-4'><Link rel='stylesheet' to="/submit-form">Next</Link></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SetupYourProfile
